import fetch from 'lib/fetch';
import { WorkspaceRole } from 'lib/models';
import Parse, { escapeMatchesQueryArg } from 'lib/parse';

interface IOption {
  label: string;
  value: string;
}

export const getWorkspaceRoleOptionsByName = async (name: string): Promise<IOption[]> => {
  // 这里查询系统的空间角色，没有绑定空间的workspaceRole
  const query = new Parse.Query(WorkspaceRole).select(['objectId', 'name']).doesNotExist('workspace');
  if (name) {
    query.matches('name', escapeMatchesQueryArg(name), 'i');
  }
  const results = await query.descending('createdAt').find();

  return results.map(role => {
    return {
      value: role.id,
      label: role.get('name'),
    };
  });
};

export const getWorkspaceRoleOptionsByValues = async (
  values: string[],
  isGlobalWorkspaceRole = true,
  workspaceKey?: string,
): Promise<IOption[]> => {
  if (!values.length) {
    return [];
  }
  const query = new Parse.Query(WorkspaceRole).containedIn('objectId', values).select(['objectId', 'name']);
  if (isGlobalWorkspaceRole) {
    // 这里查询系统的空间角色，没有绑定空间的workspaceRole
    query.doesNotExist('workspace');
  }

  let results = await query.descending('createdAt').find();

  // 查询空间内空间角色
  // 处理表单回显，角色已从权限方案中移除时
  if (workspaceKey) {
    const workspaceRoles = await fetch.get(`/workspaceRoles/${workspaceKey}`);
    results = results.map(role => (workspaceRoles?.data?.some(r => r.objectId === role.id) ? role : null));
  }

  return results.filter(Boolean).map(role => {
    return {
      value: role.id,
      label: role.get('name'),
    };
  });
};
